import type { CourseModule } from "@/core/types";
import { lektionDokumentvorlagen } from "./lektion-01-dokumentvorlagen";
import { lektionDesigns } from "./lektion-02-designs";

export const modulVorlagen: CourseModule = {
  id: "vorlagen",
  title: "Dokumentvorlagen und Designs",
  summary:
    "Wiederkehrende Dokumente einmal aufsetzen und als Vorlage bereitstellen – " +
    "und das Aussehen über Designs zentral steuern.",
  level: "Aufbau",
  lessons: [lektionDokumentvorlagen, lektionDesigns],
};
